export const imgSizes = {
    DEFAULT_SIZE_SMALL: {
        WIDTH: 150,
        HEIGHT: 150,
    }
}


// WEBPACK FOOTER //
// ./src/constants/imgSizes.js